module.exports = __webpack_public_path__ + "static/img/38.42456e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/38.png
// module id = IXpO
// module chunks = 0